var map = {
	"./3.png": 706,
	"./AliffLogo.png": 707,
	"./Why Us.png": 1533,
	"./about1.png": 1534,
	"./about2.png": 1535,
	"./abroad-image.png": 708,
	"./abroad-img1.png": 1536,
	"./abroad-img2.png": 1537,
	"./abroad-img3.png": 1538,
	"./aliff-small.png": 1539,
	"./check-icon.png": 188,
	"./community.png": 240,
	"./edu.png": 1540,
	"./events.png": 241,
	"./footer-icon.png": 1541,
	"./google.png": 709,
	"./harry.png": 1542,
	"./joe.png": 1543,
	"./live.svg": 242,
	"./minus.png": 710,
	"./msg.png": 1544,
	"./people_alt.png": 1545,
	"./plus.png": 711,
	"./prefer.png": 1546,
	"./sarah.png": 1547,
	"./sophie.png": 1548,
	"./stanford.png": 1549,
	"./star.png": 157,
	"./terry.png": 1550,
	"./title.png": 1551,
	"./vector.png": 1552,
	"./whitney.png": 1553
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 54;


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/student-enquiry-form ^\.\/.*$
// module id = 54
// module chunks = 1